module.exports = __webpack_public_path__ + "static/media/Supplier.36421cc5.svg";